module.exports = __webpack_public_path__ + "static/media/DionMisicProfile.a15b95bc.jpg";